export default function StatCard({ label, value, icon: Icon, tone = "navy", testId }) {
  const tones = {
    navy: "bg-[#1B3A6B]/10 text-[#1B3A6B]",
    blue: "bg-blue-50 text-blue-600",
    orange: "bg-orange-50 text-orange-600",
    green: "bg-green-50 text-green-600",
    red: "bg-red-50 text-red-600",
    slate: "bg-slate-100 text-slate-600",
  };
  return (
    <div
      data-testid={testId}
      className="bg-white border border-slate-200 rounded-md p-4 md:p-5 flex items-center gap-4 hover:shadow-sm hover:-translate-y-[1px] transition-[box-shadow,transform] duration-150"
    >
      <div className={`h-11 w-11 rounded-sm flex items-center justify-center shrink-0 ${tones[tone]}`}>
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <div className="text-[11px] font-semibold uppercase tracking-[0.15em] text-slate-500 truncate">{label}</div>
        <div className="text-2xl font-bold text-slate-900 tnum leading-tight">{value}</div>
      </div>
    </div>
  );
}
